import React, { useState } from "react";
import {
    updateAdminPaymentStatus,
    processRefund,
    processSettlement,
} from "../../services/adminApi";

import "../../styles/PaymentActions.css";

const PaymentActions = ({ payment, onRefresh }) => {

    const [status, setStatus] = useState(
        payment?.payment?.status || "Pending"
    );

    const [refundAmount, setRefundAmount] = useState("");

    const [refundReason, setRefundReason] = useState("");

    const [loading, setLoading] = useState(false);

    const updateStatus = async () => {

        try {

            setLoading(true);

            await updateAdminPaymentStatus(payment._id, status);

            onRefresh();

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);

        }

    };

    const refund = async () => {

        try {

            setLoading(true);

            await processRefund(payment._id, {
                amount: refundAmount,
                reason: refundReason,
            });

            onRefresh();

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);

        }

    };

    const settlement = async () => {

        try {

            setLoading(true);

            await processSettlement(payment._id);

            onRefresh();

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);

        }

    };

    return (

        <div className="payment-actions">

            <div className="action-card">

                <h3>Update Payment Status</h3>

                <select
                    value={status}
                    onChange={(e) =>
                        setStatus(e.target.value)
                    }
                >

                    <option>Pending</option>

                    <option>Authorized</option>

                    <option>Success</option>

                    <option>Failed</option>

                    <option>Refunded</option>

                </select>

                <button
                    onClick={updateStatus}
                    disabled={loading}
                >
                    Update Status
                </button>

            </div>

            <div className="action-card">

                <h3>Process Refund</h3>

                <input
                    type="number"
                    placeholder="Refund Amount"
                    value={refundAmount}
                    onChange={(e) =>
                        setRefundAmount(e.target.value)
                    }
                />

                <textarea
                    placeholder="Refund Reason"
                    value={refundReason}
                    onChange={(e) =>
                        setRefundReason(e.target.value)
                    }
                />

                <button
                    onClick={refund}
                    disabled={loading}
                >
                    Process Refund
                </button>

            </div>

            <div className="action-card">

                <h3>Settlement</h3>

                <button
                    onClick={settlement}
                    disabled={loading}
                >
                    Complete Settlement
                </button>

            </div>

        </div>

    );

};

export default PaymentActions;